"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleEvent = void 0;
var content_1 = require("../content");
var school_1 = require("../school");
var user_1 = require("./user");
var properties = ['id', 'account_id', 'begin_at', 'end_at', 'status', 'user_service_id', 'meeting_id', 'participants_limit', 'participants_left', 'details', 'notes', 'parent_id', 'school_id', 'generation_status', 'alert'];
var dateProperties = ['begin_at', 'end_at'];
/** Отдельное событие расписания пользователя */
var SingleEvent = /** @class */function () {
  function SingleEvent(values) {
    if (values === void 0) {
      values = {};
    }
    var instance = this;
    Object.keys(values).forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('account' in values) {
      instance.account = new user_1.User(values.account);
    }
    if ('meeting' in values) {
      instance.meeting = new content_1.Meeting(values.meeting);
    }
    if ('user_service' in values) {
      instance.user_service = new content_1.UserService(values.user_service);
    }
    if ('user_service_contract' in values) {
      instance.user_service_contract = new content_1.UserServiceContract(values.user_service_contract);
    }
    if ('school' in values) {
      instance.school = new school_1.CSchool(values.school);
    }
    // преобразование дат
    dateProperties.forEach(function (p) {
      if (p in instance && instance[p]) {
        instance[p] = new Date(instance[p]);
      }
    });
  }
  return SingleEvent;
}();
exports.SingleEvent = SingleEvent;
